import React, { Component } from 'react'
import Link from 'gatsby-link'
import {withPrefix} from 'gatsby-link'
import Modal from 'react-modal';
import Img from 'gatsby-image'

import './modal.css';

const modalStyles = {
  content : {
    position: 'absolute',
    top: '0%',
    left: '0%',
    width: '100%',
    height: '100%',
    backgroundColor: 'black',
    border: 'transparent',
  },
  overlay : {
    zIndex: 20000,
  }
};

const defaultHeight = 715;

class ModalImage extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isOpen : false,
      descriptionVisible : false,
      height: defaultHeight,
    }

    this.showDescription = this.showDescription.bind(this);
    this.hideDescription = this.hideDescription.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal() {
    this.setState({isOpen : true});
  }

  closeModal() {
    this.setState({isOpen : false});
  }

  showDescription() {
    this.setState({descriptionVisible : true});
  }

  hideDescription() {
    this.setState({descriptionVisible : false});
  }

  renderOverlay(description) {
    let style = this.state.descriptionVisible ? {backgroundColor : '#4C4C4C', color : 'white'} : {};

    return (
      <div style = {style} className="modal-text-overlay">
        {description}
      </div>
    );
  }

  render () {
    let description = this.renderOverlay(this.props.description);

    return (
    <div>

      <div onClick={this.openModal}>
        <Img style={{cursor: 'pointer', marginBottom: 20}} sizes={this.props.sizes}></Img>
      </div>
      <Modal
        isOpen={this.state.isOpen}
        onRequestClose={this.closeModal}
        closeTimeoutMS={150}
        style={modalStyles}>

          <div
            onMouseEnter={this.showDescription}
            onMouseLeave={this.hideDescription}
            className="modal-wrapper">

              <img className="modal-img" src= {withPrefix(this.props.src)}/>

              {description}

          </div>

          <div className="close-button" onClick={this.closeModal}>
            ×
          </div>

      </Modal>

    </div>
    );
  }
}


export default {ModalImage}



// WEBPACK FOOTER //
// ./src/components/ModalImage/index.js